/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {CalendarTask} from '../calendar-task';

export class CalendarClickEvent {
  public x: number;
  public y: number;
  public task: CalendarTask;

  constructor(event: MouseEvent, task?: CalendarTask) {
    this.x = event.clientX;
    this.y = event.clientY;
    this.task = task;
  }
}
